import { BIA_CATEGORY_POOL } from './constants.js';
import { normalizeTimeHorizons } from './time-horizon.js';

/**
 * System default BIA impact configuration (lazy customization baseline).
 * @returns {import('./resolve.js').EffectiveBiaImpactConfiguration}
 */
export function buildSystemDefaultBiaImpactConfiguration() {
    const categories = BIA_CATEGORY_POOL.map((categoryKey) => ({ categoryKey }));
    const timeHorizons = normalizeTimeHorizons([
        { id: 'h2', value: 2, unit: 'hours' },
        { id: 'h8', value: 8, unit: 'hours' },
        { id: 'h24', value: 24, unit: 'hours' },
        { id: 'd2', value: 2, unit: 'days' },
        { id: 'w1', value: 1, unit: 'weeks' },
    ]);

    return {
        isCustomized: false,
        categories,
        timeHorizons,
        calculationModel: 'SIMPLE_AVERAGE',
        mtpdThreshold: 3,
        rtoThreshold: 3,
        rpoThreshold: 3,
    };
}
